import * as yup from "yup";

import { Box, Grid } from '@mui/material';
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, EnhancedCheckboxRHFWithLabel, EnhancedDropDownRHFWithLabel, LabelPosition, RHookFormNumberFieldWithLabel, RHookFormTextFieldWithLabel, StandardPanel } from '@websential/cosmic-v20';
import { FormProvider, useForm } from 'react-hook-form';
import React, { useEffect, useState } from 'react'
import { sortDDLByLabel, useNavigateToLogout } from "../../../../../common/Common";

import { TransactionsServices } from "../../../../../services/DirectDeposit/TransactionsServices";
import { useQuery } from "@tanstack/react-query";
import { yupResolver } from "@hookform/resolvers/yup";

const SINGLE_RECORD_DATA_QUERY_KEY = "departments-single-data-record";

interface IErrorMessageSetupFormFields {
    errorMessagesDDL: any;
    updatedErrorMessagesDDL: (value: any) => void;
    onErrorMessageChangeHandler?: () => void;
    onSaveErrorMessageClickedHandler: (values: any) => void;
    onCloseErrorMessageHandler: () => void;
}

const useGetData = (
    id: string | undefined,
    navigateToLogout: (path: string) => void
) =>
    useQuery({
        queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id, navigateToLogout],
        queryFn: () => {
            return TransactionsServices.getERrorMessageById(id, navigateToLogout);
        },
        refetchOnWindowFocus: false,
    });

export const ErrorMessageSetupFormFields: React.FC<IErrorMessageSetupFormFields> = ({ errorMessagesDDL,
    // onErrorMessageChangeHandler, 
    updatedErrorMessagesDDL,
    onSaveErrorMessageClickedHandler, onCloseErrorMessageHandler }) => {
    const navigateToLogout = useNavigateToLogout();

    const [panalty, setPanalty] =
        useState<boolean>(false);
    const [isLoadingAPI, setIsLoadingAPI] =
        useState<any>(false);
    const [loadedMessageId, setLoadedMessageId] =
        useState<any>(undefined);
    const [errorMessagesDDLState, setErrorMessagesDDLState] =
        useState<any>(undefined);
    useEffect(() => {
        if (errorMessagesDDL) {
            let errorMessageList: any[] =
                sortDDLByLabel(errorMessagesDDL).map((errorMessage: any) => ({
                    label: errorMessage.label,
                    value: errorMessage.value
                }));

            errorMessageList.unshift({
                label: "Create New",
                value: "create-new",
            });

            setErrorMessagesDDLState(errorMessageList);
        }
    }, [errorMessagesDDL]);

    const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
        loadedMessageId,
        navigateToLogout
    );


    const validationSchema = yup.object({
        name: yup.string().required('Name is required'),
        errorType: yup.number().required('Error Type is required'),
    });

    const formMethods = useForm<any>({
        resolver: yupResolver(validationSchema),
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const onSubmit = async (values: any) => {
        (async () => {
            try {
                setIsLoadingAPI(true)
                const response: any =
                    await TransactionsServices.saveErrorMessageInProcessCollectionTransactions(loadedMessageId, values);
                if (response.status === 201 || response.status === 200) {
                    formMethods.setValue("loadMessage", response.data.id);
                    setLoadedMessageId(response.data.id);
                    (async () => {
                        try {
                            setIsLoadingAPI(true)
                            const response: any =
                                await TransactionsServices.getErrorMessageDDL();
                            let errorMessageList: any[] =
                                response.map((errorMessage: any) => ({
                                    label: errorMessage.label,
                                    value: errorMessage.value
                                }));

                            errorMessageList.unshift({
                                label: "Create New",
                                value: "create-new",
                            });
                            updatedErrorMessagesDDL(response)
                            setErrorMessagesDDLState(errorMessageList)
                        } catch { } finally {
                            setIsLoadingAPI(false)
                        }
                    })();
                }
            } catch { } finally {
                setIsLoadingAPI(false)
            }
        })();
    }

    const onErrorMessageChangeHandler = (item: any) => {
        if (item.value !== "create-new") {
            setLoadedMessageId(item.value)
        } else {
            setLoadedMessageId(undefined)
            formMethods.setValue("name", undefined);
            formMethods.setValue("errorType", undefined);
            formMethods.setValue("panalty", undefined);
            formMethods.setValue("amount", null);
        }
    }

    useEffect(() => {
        if (loadedMessageId && selectedDataRecord) {

            Object.keys(selectedDataRecord).forEach((fieldName) => {
                const fieldValue = selectedDataRecord[fieldName];
                formMethods.setValue(fieldName, fieldValue ?? undefined);
                if (fieldName === 'id') {
                    formMethods.setValue("loadMessage", fieldValue);
                }
                if (fieldName === 'errorType') {
                    formMethods.setValue("errorType", Number(fieldValue));
                }
            });
        }
    }, [loadedMessageId, selectedDataRecord]);

    const onPenaltySelectionChangeHandler = (selected: any) => {
        setPanalty(selected)
    }


    return (
        <Grid sx={{ "& .numberFieldWrapper": { marginBottom: "0!important" } }}>
            <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(onSubmit)}>
                    <StandardPanel title={''} showTitle={false} testId={"undefined"}>
                        <EnhancedDropDownRHFWithLabel
                            selectName="loadMessage"
                            label="Load Message"
                            labelPosition={LabelPosition.Left}
                            // required
                            testId={`country-list`}
                            items={errorMessagesDDLState ?? []}
                            // items={[]}
                            labelColumns={4}
                            fieldColumns={8}
                            onSelectionChangeHandler={onErrorMessageChangeHandler}
                        />
                        <RHookFormTextFieldWithLabel
                            label="Name"
                            id="name"
                            testId={`account-title`}
                            labelPosition={LabelPosition.Left}
                            labelColumns={4}
                            fieldColumns={8}
                            required
                        />
                        <EnhancedDropDownRHFWithLabel
                            selectName="errorType"
                            label="Error Type"
                            labelPosition={LabelPosition.Left}
                            required
                            testId={`type-list`}
                            items={[
                                { label: "Collection", value: 200 },
                                { label: "Payment", value: 300 },
                                { label: "Both Collection & Payment", value: 100 }
                            ]}
                            labelColumns={4}
                            fieldColumns={8}
                        // onSelectionChangeHandler={onErrorMessageChangeHandler}
                        />
                        <EnhancedCheckboxRHFWithLabel
                            name="panalty"
                            checked={false}
                            testId="panalty"
                            labelPosition={LabelPosition.Left}
                            labelColumns={4}
                            fieldColumns={8}
                            // label={"Default Accountant"}
                            // checkboxLabel="Default Accountant" 
                            label={'Penalty'}
                            onSelectionChangeHandler={onPenaltySelectionChangeHandler}
                        />
                        {panalty && <EnhancedDropDownRHFWithLabel
                            selectName="taxable"
                            label="Taxable"
                            labelPosition={LabelPosition.Left}
                            testId={`taxable-list`}
                            items={[{ label: "Taxable", value: 200 }, { label: "Non-Taxable", value: 100 }]}
                            selectedItem={100}
                            labelColumns={4}
                            fieldColumns={8}
                        />}
                        <RHookFormNumberFieldWithLabel
                            label="Amount"
                            id="amount"
                            testId={`amount`}
                            labelPosition={LabelPosition.Left}
                            labelColumns={4}
                            fieldColumns={8}
                        />
                    </StandardPanel>

                    <Box sx={{ display: "flex", justifyContent: "flex-end", padding: "16px", paddingBottom: 0 }}>
                        <EnhancedButtonPrimeReact
                            label="Cancel"
                            severity="secondary"
                            text
                            raised
                            onClickHandler={onCloseErrorMessageHandler}
                            style={{ fontSize: "small" }}
                        />
                        <EnhancedButtonPrimeReact
                            label="Save"
                            type="submit"
                            raised
                            severity={EnhancedButtonPrimeReactSeverity.Success}
                            style={{ marginLeft: "16px", fontSize: "small" }}
                            loading={isLoadingAPI}
                        />
                    </Box>

                </form>
            </FormProvider>
        </Grid>
    );
}
